import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class KeycloakInitService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  init(): Promise<void> {
    if (!isPlatformBrowser(this.platformId)) return Promise.resolve();

    // Already logged in — nothing to do.
    if (localStorage.getItem('token')) return Promise.resolve();

    // The callback route is already handling a code/error from Keycloak.
    if (window.location.pathname.startsWith('/auth/callback')) return Promise.resolve();

    // Auto-login ONLY when the user arrived from another site (the portal).
    // A direct visit (typed URL / bookmark → empty referrer) shows the Sign In
    // page on the first load — we never redirect direct visitors.
    if (!this.cameFromExternal()) return Promise.resolve();

    // Attempt once per tab to avoid redirect loops.
    if (sessionStorage.getItem('kc_sso_attempted')) return Promise.resolve();
    sessionStorage.setItem('kc_sso_attempted', '1');

    // FULL auth redirect (NOT prompt=none — Ampersand's realm errors on that).
    // An active portal session (same realm) redirects back instantly and logs
    // the user in; if there is no session, Keycloak shows its own login form.
    const kc = environment.keycloak;
    const params = new URLSearchParams({
      client_id: kc.clientId,
      redirect_uri: window.location.origin + '/auth/callback',
      response_type: 'code',
      scope: 'openid profile email',
    });
    window.location.href = `${kc.url}realms/${kc.realm}/protocol/openid-connect/auth?${params}`;

    // Page is navigating away — pause bootstrap so the login UI doesn't flash.
    // Safety timeout in case navigation is blocked.
    return new Promise<void>((resolve) => setTimeout(resolve, 5000));
  }

  /** True when the user landed here from a different site (i.e. the portal). */
  private cameFromExternal(): boolean {
    try {
      const ref = document.referrer;
      if (!ref) return false;
      return new URL(ref).hostname !== window.location.hostname;
    } catch {
      return false;
    }
  }
}
